import { RouterProvider } from 'react-router-dom';

import { ErrorBoundary } from '@shared/components';

import Splash from '@/components/shared/Splash';

import { router } from './router/router';

const Vendor = () => {
	return (
		<ErrorBoundary>
			<RouterProvider router={router} fallbackElement={<Splash />} />
		</ErrorBoundary>
	);
};

export default Vendor;
